import React, { memo, ReactElement } from "react";
import classNames from "classnames";
import {
    canValueTextStrikeoff,
    getValueTextFontStyles,
    isBillItemMetaDatatypeIsString,
} from "@core-ui/helpers/BillDetailsHelper";
import { RenderingDetailsMeta } from "@swiggy-private/cart-types";
import { RENDERING_DETAILS_TYPES } from "@core-ui/constants/RenderingDetails";

import styles from "../../../BillDetailItem.scss";

const ValueText = ({
    meta,
    value,
    isNegative,
    itemKey,
}: {
    meta: RenderingDetailsMeta;
    value?: string | number;
    isNegative?: boolean;
    itemKey: string;
}): ReactElement | null => {
    const className = classNames(styles.displayInfoTextInTooltipPrice, {
        [styles.displayValueStrikeoff]: canValueTextStrikeoff({ meta }),
    });

    const valueClassName = classNames(styles.displayInfoTextValue, {
        [styles.rupee]:
            !isBillItemMetaDatatypeIsString({ meta }) || itemKey.toUpperCase() === RENDERING_DETAILS_TYPES.ITEM_TOTAL,
        [styles.displayValuePadded]: isNegative,
        [styles.rupeeBold]: itemKey.toUpperCase() === RENDERING_DETAILS_TYPES.GRAND_TOTAL,
        [styles.addTip]: itemKey.toUpperCase() === RENDERING_DETAILS_TYPES.ADD_DELIVERY_TIP, //black color for platform fee
    });

    const fontStyles = getValueTextFontStyles({ meta });

    return (
        <div className={className} style={fontStyles}>
            <span className={styles.negative}>{isNegative ? "-" : ""}</span>
            <span className={valueClassName}>{value}</span>
        </div>
    );
};

export default memo(ValueText);
